import { BodyM, HeadingM } from '@/legacy/components/Typography'

import { usePartnerSearch } from '../core/PartnerSearchContext'
import { SectionStyles } from '../styles'

const TextSection = () => {
  const { title, subtitle } = usePartnerSearch()

  if (!title && !subtitle) return null
  return (
    <SectionStyles>
      {title && (
        <HeadingM className="partner__title" tag={title.tag || 'h2'}>
          {title.text}
        </HeadingM>
      )}
      {subtitle && (
        <BodyM className="partner__description" tag={subtitle.tag || 'p'}>
          {subtitle.text}
        </BodyM>
      )}
    </SectionStyles>
  )
}
export default TextSection
